module.exports = __webpack_public_path__ + "static/media/AlternateGotNo2D-01.137b41bc.svg";